
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'
import { defineComponent } from 'vue'

import { fetchWorkoutInsights, WorkoutInsights } from '../graphql'
import {
  formatInsightNumber,
  formatPeriodLabel,
  formatWeek,
  newerWeekOffset,
  olderWeekOffset,
} from '../insights'
import { createInsightsLoader } from './insights-loader'

export default defineComponent({
  name: 'WorkoutInsights',
  components: { Button, ProgressSpinner },
  mixins: [createInsightsLoader<WorkoutInsights>(fetchWorkoutInsights)],
  computed: {
    maxWeeklyWorkouts(): number {
      return Math.max(0, ...(this.insights?.weeklyCompletedWorkouts.map(week => week.completedWorkouts) ?? []))
    },
    weeklyTrendDescription(): string {
      if (!this.insights) return 'Workouts done per week'
      return this.insights.weeklyCompletedWorkouts
        .map(week => `${formatWeek(week.weekStart)}: ${week.completedWorkouts} finished workouts`)
        .join(', ')
    },
    selectedPeriodLabel(): string {
      return formatPeriodLabel(this.insights?.weeklyCompletedWorkouts.map(week => week.weekStart) ?? [])
    },
  },
  methods: {
    formatNumber: formatInsightNumber,
    formatWeekLabel: formatWeek,
    formatMinutes(value: number): string {
      const minutes = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 1,
      }).format(value)
      return `${minutes} min`
    },
    barHeight(completedWorkouts: number): number {
      if (this.maxWeeklyWorkouts === 0) return 3
      return Math.max(3, (completedWorkouts / this.maxWeeklyWorkouts) * 100)
    },
    showOlderWeeks() {
      if (!this.insights?.hasOlderWeeks) return
      this.loadInsights(olderWeekOffset(this.insights.weekOffset))
    },
    showNewerWeeks() {
      if (!this.insights?.hasNewerWeeks) return
      this.loadInsights(newerWeekOffset(this.insights.weekOffset))
    },
  },
})
